<template>
  <div>
    <cabecera></cabecera>
   
    <router-view/>
    <pie></pie>
   
  </div>
</template>
<script>

import cabecera from '../components/cabecera.vue'
import pie from '../components/pie.vue'
import panel from '../components/panel.vue'


export default {
  name: 'gestion',
  components: {
    cabecera, 
    panel,
    pie,
  },
  beforeRouteEnter (to, from, next) { 
     next()
     /*if (this.$store.state.login) {
        next()
      } else {
        next(false)
      }*/
  }

}
</script>
</script>
<style  lang="scss"  scoped src="../sass/gestion.scss"></style>



// WEBPACK FOOTER //
// src/components/gestion.vue